(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aco-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aco-hero-slideshow')) {
    customElements.define('aco-hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.aco-slideshow__track');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.toggle = this.querySelector('[data-toggle]');
        this.status = this.querySelector('[data-status]');
        this.index = 0;
        this.paused = false;
        this.hovering = false;
        this.visible = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const controls = this.querySelector('[data-controls]');
        if (!this.track || this.slides.length < 2) {
          if (this.track) this.track.removeAttribute('tabindex');
          return;
        }
        if (controls) controls.hidden = false;
        this.addEventListener('pointerdown', (event) => {
          if (event.target.closest('[data-toggle]')) this.toggleNextPaused = !this.paused;
        }, { signal });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-toggle')) {
            this.paused = this.toggleNextPaused ?? !this.paused;
            delete this.toggleNextPaused;
            this.schedule();
          } else if (button.hasAttribute('data-previous')) {
            this.goTo(this.index - 1, true);
          } else if (button.hasAttribute('data-next')) {
            this.goTo(this.index + 1, true);
          } else if (button.hasAttribute('data-dot')) {
            this.goTo(Number(button.dataset.dot), true);
          }
        }, { signal });
        this.track.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
          this.goTo(next, true);
        }, { signal });
        this.track.addEventListener('pointerdown', () => {
          this.paused = true;
          this.schedule();
        }, { signal, passive:true });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            const edge = this.track.getBoundingClientRect().left;
            let nearest = 0;
            let distance = Infinity;
            this.slides.forEach((slide, index) => {
              const currentDistance = Math.abs(slide.getBoundingClientRect().left - edge);
              if (currentDistance < distance) {
                nearest = index;
                distance = currentDistance;
              }
            });
            this.index = nearest;
            this.update();
          });
        }, { signal, passive:true });
        this.addEventListener('mouseenter', () => { this.hovering = true; this.schedule(); }, { signal });
        this.addEventListener('mouseleave', () => { this.hovering = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', (event) => {
          if (!this.contains(event.relatedTarget)) this.paused = true;
          this.schedule();
        }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.motion.addEventListener('change', () => this.schedule(), { signal });
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.goTo(index, true);
        }, { signal });
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.schedule();
        }, { threshold:0.1 });
        this.observer.observe(this);
        this.resizeObserver = new ResizeObserver(() => {
          this.track.scrollTo({ left:this.slides[this.index].offsetLeft - this.slides[0].offsetLeft, behavior:'instant' });
        });
        this.resizeObserver.observe(this.track);
        this.update();
        this.schedule();
      }
      goTo(index, manual = false) {
        this.index = (index + this.slides.length) % this.slides.length;
        if (manual) this.paused = true;
        this.track.scrollTo({ left:this.slides[this.index].offsetLeft - this.slides[0].offsetLeft, behavior:this.motion.matches ? 'instant' : 'smooth' });
        this.update();
        if (manual) this.status.textContent = this.slides[this.index].getAttribute('aria-label');
        this.schedule();
      }
      update() {
        this.slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== this.index)));
        this.dots.forEach((dot, index) => {
          if (index === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      schedule() {
        clearTimeout(this.timer);
        const wantsPlayback = this.dataset.autoplay === 'true' && !this.paused && !this.motion.matches;
        if (this.toggle) {
          this.toggle.textContent = wantsPlayback ? this.dataset.pauseLabel : this.dataset.playLabel;
          this.toggle.disabled = this.motion.matches;
        }
        if (wantsPlayback && this.visible && !this.hovering && !document.hidden && !window.Shopify?.designMode) {
          this.timer = setTimeout(() => this.goTo(this.index + 1), Number(this.dataset.interval) || 6000);
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        cancelAnimationFrame(this.scrollFrame);
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
